// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer .logo-image {
  left: -40px;
}
footer .navigation-container ul li a {
  text-decoration: none;
}
footer .navigation-container ul li a:hover {
  font-weight: bold;
  color: var(--primary-color) !important;
}
footer .social-container {
  grid-template-columns: repeat(5, 2rem);
}
footer .social-container > * {
  font-size: 1.2rem;
}
footer .social-container > * > * {
  translate: -50% -50%;
}
footer .social-container > *:hover {
  color: var(--primary-color);
}
footer .post-footer-wrapper:before {
  content: "";
  position: absolute;
  width: clamp(200px, 20vw, 300px);
  height: 1px;
  background-color: var(--text-color);
  opacity: 0.2;
  top: 0;
  left: 50%;
  translate: -50% 0;
}
footer .post-footer-wrapper app-image {
  width: 100%;
  max-width: 120px;
}

@media only screen and (max-width: 767px) {
  .pre-footer-wrapper > div:last-child {
    position: relative;
  }
  .pre-footer-wrapper > div:last-child:before {
    content: "";
    position: absolute;
    width: clamp(200px, 20vw, 300px);
    height: 1px;
    background-color: var(--text-color);
    opacity: 0.2;
    top: 0;
    left: 50%;
    translate: -50% 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/components/footer/footer.component.scss"],"names":[],"mappings":"AACE;EACE,WAAA;AAAJ;AAMQ;EACE,qBAAA;AAJV;AAMU;EACE,iBAAA;EACA,sCAAA;AAJZ;AAWE;EACE,sCAAA;AATJ;AAWI;EACE,iBAAA;AATN;AAWM;EACE,oBAAA;AATR;AAYM;EACE,2BAAA;AAVR;AAgBI;EACE,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,WAAA;EACA,mCAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,iBAAA;AAdN;AAiBI;EACE,WAAA;EACA,gBAAA;AAfN;;AAoBA;EAEI;IACE,kBAAA;EAlBJ;EAoBI;IACE,WAAA;IACA,kBAAA;IACA,gCAAA;IACA,WAAA;IACA,mCAAA;IACA,YAAA;IACA,MAAA;IACA,SAAA;IACA,iBAAA;EAlBN;AACF","sourcesContent":["footer {\r\n  .logo-image {\r\n    left: -40px;\r\n  }\r\n\r\n  .navigation-container {\r\n    ul {\r\n      li {\r\n        a {\r\n          text-decoration: none;\r\n\r\n          &:hover {\r\n            font-weight: bold;\r\n            color: var(--primary-color) !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .social-container {\r\n    grid-template-columns: repeat(5, 2rem);\r\n\r\n    > * {\r\n      font-size: 1.2rem;\r\n\r\n      > * {\r\n        translate: -50% -50%;\r\n      }\r\n\r\n      &:hover {\r\n        color: var(--primary-color);\r\n      }\r\n    }\r\n  }\r\n\r\n  .post-footer-wrapper {\r\n    &:before {\r\n      content: \"\";\r\n      position: absolute;\r\n      width: clamp(200px, 20vw, 300px);\r\n      height: 1px;\r\n      background-color: var(--text-color);\r\n      opacity: 0.2;\r\n      top: 0;\r\n      left: 50%;\r\n      translate: -50% 0;\r\n    }\r\n\r\n    app-image {\r\n      width: 100%;\r\n      max-width: 120px;\r\n    }\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 767px) {\r\n  .pre-footer-wrapper {\r\n    > div:last-child {\r\n      position: relative;\r\n\r\n      &:before {\r\n        content: \"\";\r\n        position: absolute;\r\n        width: clamp(200px, 20vw, 300px);\r\n        height: 1px;\r\n        background-color: var(--text-color);\r\n        opacity: 0.2;\r\n        top: 0;\r\n        left: 50%;\r\n        translate: -50% 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
